import { skipToken, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { OurUseQueryOptions } from "@nens/react-query-utils";
import { PaginatedRevisionTaskList, RevisionTask, getHCCApi } from "@nens/threedi/openapi-client";

export type RevisionTaskDetail = {
  result?: {
    errors?: Array<{ description: string }>;
  };
};

const getRevisionTasksQuery = (
  schematisationId: number | undefined,
  revisionId: number | undefined
): OurUseQueryOptions<PaginatedRevisionTaskList> => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-revision-tasks", schematisationId, revisionId] as const,
    queryFn:
      schematisationId !== undefined && revisionId !== undefined
        ? () =>
            getHCCApi().schematisationsRevisionsTasksList({
              revisionPk: revisionId,
              schematisationPk: schematisationId,
            })
        : skipToken,
  });
};

export const useRevisionTasksQuery = (
  schematisationId: number | undefined,
  revisionId: number | undefined
) => useQuery(getRevisionTasksQuery(schematisationId, revisionId));

export function useLatestRevisionTask(
  schematisationId: number | undefined,
  revisionId: number | undefined
): RevisionTask | null {
  const { data, isSuccess } = useRevisionTasksQuery(schematisationId, revisionId);
  if (isSuccess && data?.results[0]) {
    return data.results[0];
  }
  return null;
}
